"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAILING_PLUGINS = void 0;
exports.MAILING_PLUGINS = {
    POSTMARK: 'POSTMARK',
    SENDGRID: 'SENDGRID'
};
//# sourceMappingURL=mailingPlugins.js.map